module.exports = __webpack_public_path__ + "static/img/icon_94_top.3d401b2c.png";